<div id="map"></div>

<div #userLocation class="user-location-dot"></div>

@if (contextMenuCoords) {
  <div
    class="cm-popup"
    [style.left.px]="contextMenuCoords.x + 10"
    [style.top.px]="contextMenuCoords.y + 10"
    >
    <div class="cm-item" role="button" aria-label="Copy coordinates" (click)="copyCoord()">
      <i class="fa-solid fa-copy cm-icon" aria-hidden="true"></i>
      <span>{{ contextMenuCoords.lat.toFixed(5) }}, {{ contextMenuCoords.lng.toFixed(5) }}</span>
    </div>
    <div class="cm-divider"></div>
    <div class="cm-item" role="button" aria-label="Register damage risk" (click)="registerDamageRisk()">
      <i class="fa-solid fa-triangle-exclamation cm-icon" aria-hidden="true"></i>
      <span>{{ 'Register Damage Risk' | translate }}</span>
    </div>
  </div>
}

@if (vehicleTooltipPosition() && vehicleTooltipData()) {
  <app-vehicle-tooltip
    class="vehicle-hover-popup"
    [data]="vehicleTooltipData()"
    [style.left.px]="vehicleTooltipPosition()!.x + 12"
    [style.top.px]="vehicleTooltipPosition()!.y + 12"
    (tooltipEnter)="onTooltipEnter()"
    (tooltipLeave)="onTooltipLeave()"
  />
}
